import { render, staticRenderFns } from "./TagPikker.vue?vue&type=template&id=198cb77b&"
import script from "./TagPikker.vue?vue&type=script&lang=js&"
export * from "./TagPikker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports